import {
	faCheck,
	faChevronLeft,
	faEye,
	faTimes,
	faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import {
	Button,
	CardLink,
	Col,
	FormGroup,
	Input,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Row,
	Spinner,
} from "reactstrap";
import { store } from "react-notifications-component";
import { Dispatch } from "redux";
import { videoHotlineAction } from "../../actions/videoHotlineAction";
import { DABBackToList, LoadingSpinnerModal } from "../../components/dab";
import { showAlert } from "../common/functions";
import ReactPaginate from "react-paginate";
import updownArrows from "../../assets/images/up_down_arrows.svg";
import { getLoggedUserId } from "../../services/selectors/Accounts";
import { testimonialAction } from "../../actions/testimonialAction";
import Select from "react-select";
import { VideoHotlineService } from "../../services/api/videoHotlineService";

interface IVideoHotlineProps {
	dispatch: Dispatch<any>;
	videoHotlineData: any;
	testimonialData: any;
	title?: string;
}

const VideoHotlineList: React.SFC<IVideoHotlineProps> = ({
	dispatch,
	videoHotlineData,
	testimonialData,
	title,
}) => {
	const history = useHistory();
	const [selectedId, setSelectedId] = useState(-1);
	const [showModal, setShowModal] = useState(false);
	const [currentPage, setCurrentPage] = useState<number>(1);
	const [searchText, setSearch] = useState<string>("");
	const [debouncedSearch, setDebouncedSearch] = useState<string>("");
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [columnSort, setColumnSort] = useState<any>(null);
	const [selectedStatus, setSelectedStatus] = useState<any>(null);
	const [selectedCategory, setSelectedCategory] = useState<any>(null);
	const [eventCategoryList, setEventCategoryList] = useState<any[]>([]);

	React.useEffect(() => {
		const handler = setTimeout(() => {
			setCurrentPage(1);
			setDebouncedSearch(searchText);
		}, 400);
		return () => {
			clearTimeout(handler);
		};
	}, [searchText]);

	React.useEffect(() => {
		const fetchDropdown = async () => {
			const dropdownList: any =
				await VideoHotlineService.getEventCategoriesApi();
			setEventCategoryList(dropdownList?.activeEventCategories);
		};
		fetchDropdown();
	}, []);

	React.useEffect(() => {
		if (videoHotlineData?.message?.messageBoardId) {
			const body = {
				sortDirection: columnSort?.direction ?? "",
				sortColumn: columnSort?.column ?? "",
				pageNumber: currentPage,
				pageSize: 25,
				searchText: debouncedSearch,
				messageBoardId: videoHotlineData?.message?.messageBoardId,
				status: isNaN(selectedStatus) ? null : parseInt(selectedStatus),
				eventCategoryId: isNaN(selectedCategory) ? null : parseInt(selectedCategory),
			};
			setShowModal(true);
			dispatch(videoHotlineAction.videoHotlineGetByfilter(body));
		}
	}, [debouncedSearch, columnSort]);

	const handleLoadShowModal = (value: boolean) => {
		setShowModal(value);
	};

	if (
		videoHotlineData &&
		!videoHotlineData.isLoading &&
		videoHotlineData.isListSuccess
	) {
		videoHotlineData.isListSuccess = false;
		if (showModal) {
			setShowModal(false);
		}
	}

	if (
		selectedId >= 0 &&
		videoHotlineData.isSuccess &&
		videoHotlineData.isDeleteCompleted &&
		!videoHotlineData.isError
	) {
		showAlert(videoHotlineData.status, false);
		videoHotlineData.isSuccess = false;
		videoHotlineData.isDeleteCompleted = false;
		const body = {
			sortDirection: columnSort?.direction ?? "",
			sortColumn: columnSort?.column ?? "",
			pageNumber:
				videoHotlineData?.items?.allMessages?.length === 1
					? currentPage - 1
					: currentPage,
			pageSize: 25,
			searchText: debouncedSearch,
			messageBoardId: videoHotlineData?.message?.messageBoardId,
			status: isNaN(selectedStatus) ? null : parseInt(selectedStatus),
			eventCategoryId: isNaN(selectedCategory) ? null : parseInt(selectedCategory),
		};
		setShowModal(true);
		dispatch(videoHotlineAction.videoHotlineGetByfilter(body));
		setCurrentPage(
			videoHotlineData?.items?.allMessages?.length === 1
				? currentPage - 1
				: currentPage
		);
		setSelectedId(-1);
	}
	if (!videoHotlineData.isSuccess && videoHotlineData.isError) {
		if (videoHotlineData.status === "Unauthorized") {
			history.push("/401");
		} else {
			showAlert(videoHotlineData.status, true);
		}
		videoHotlineData.isError = false;
		setSelectedId(-1);
		if (showModal) {
			setShowModal(false);
		}
	}

	React.useEffect(() => {
		if (testimonialData?.isUpdateStatus) {
			const body = {
				sortDirection: columnSort?.direction ?? "",
				sortColumn: columnSort?.column ?? "",
				pageNumber: currentPage,
				pageSize: 25,
				searchText: debouncedSearch,
				messageBoardId: videoHotlineData?.message?.messageBoardId,
				status: isNaN(selectedStatus) ? null : parseInt(selectedStatus),
				eventCategoryId: isNaN(selectedCategory) ? null : parseInt(selectedCategory),
			};
			dispatch(videoHotlineAction.videoHotlineGetByfilter(body));
			const alertMessage = testimonialData?.status;
			if (alertMessage && alertMessage != "") {
				store.addNotification({
					title: "Success!",
					message: alertMessage,
					type: "success",
					insert: "top",
					container: "top-right",
					animationIn: ["animate__animated", "animate__fadeIn"],
					animationOut: ["animate__animated", "animate__fadeOut"],
					dismiss: {
						duration: 5000,
						onScreen: true,
					},
				});
				testimonialData.isUpdateStatus = false;
				window.localStorage.setItem("alertMessage", "");
			}
		}
	}, [testimonialData?.isUpdateStatus]);

	React.useEffect(() => {
		if (!videoHotlineData?.message?.messageBoardId) {
			dispatch(videoHotlineAction.getMessageBoardID("videohotline"));
		}
		if (!!videoHotlineData?.message?.messageBoardId) {
			const body = {
				sortDirection: columnSort?.direction ?? "",
				sortColumn: columnSort?.column ?? "",
				pageNumber: currentPage,
				pageSize: 25,
				searchText: debouncedSearch,
				messageBoardId: videoHotlineData?.message?.messageBoardId,
				status: isNaN(selectedStatus) ? null : parseInt(selectedStatus),
				eventCategoryId: isNaN(selectedCategory) ? null : parseInt(selectedCategory),
			};
			dispatch(videoHotlineAction.videoHotlineGetByfilter(body));
		}
		setShowModal(true);
	}, [videoHotlineData?.message?.messageBoardId]);

	const videoEnhanceStatus = (status) => {
		switch (status) {
			case 0:
				return "Enhancement in Progress";
			case 1:
				return "Enhanced Video";
			case 2:
				return "Original Video";
			default:
				return "Original Video";
		}
	};
	const getColorByVideoStatus = (status: any) => {
		switch (status) {
			case 0:
				return "#FFC300";
			case 1:
				return "#008001";
			case 2:
				return "#007bff";
			default:
				return "#007bff";
		}
	};
	function getUserFullName(data) {
		const fullName = `${data?.messageDTO?.createdByUser?.firstName ?? ""} ${
			data?.messageDTO?.createdByUser?.lastName ?? ""
		}`.trim();
		const maxLength = 90;
		return fullName.length > maxLength
			? fullName.slice(0, maxLength) + "…"
			: fullName;
	}

	const handleSelectForDelete = (id: any) => {
		setSelectedId(id);
		setShowDeleteModal(true);
	};

	const handleCloseClick = () => {
		setShowDeleteModal(false);
	};

	const handleLoadDeleteModal = () => {
		dispatch(videoHotlineAction.videoHotlineDelete(selectedId));
		setShowModal(true);
		setShowDeleteModal(false);
	};

	const handleManageCategory = () => {
		window.location.href = "/managehotlinecategory";
	};

	const handleSort = (sortColumn) => {
		const direction =
			sortColumn === columnSort?.column
				? columnSort?.direction === "desc"
					? "asc"
					: "desc"
				: "desc";
		setColumnSort({ column: sortColumn, direction: direction });
	};
	const handleGetSortColumn = (display, value) => {
		return (
			<div
				className="column-div d-flex"
				onClick={(e) => {
					handleSort(value);
				}}
			>
				{display}
				<img src={updownArrows} alt="updownArrows" />
			</div>
		);
	};

	const approveVideo = async (id: number) => {
		try {
			const data = {
				adminUserId: parseInt(getLoggedUserId()),
				messageId: id,
				isApproved: true,
			};
			setShowModal(true);
			await dispatch(testimonialAction.updateTestimonialStatus(data));
		} catch (error) {
			console.error("Failed to approve videoHotline:", error);
		}
	};

	const rejectVideo = async (id: number) => {
		try {
			const data = {
				adminUserId: parseInt(getLoggedUserId()),
				messageId: id,
				isApproved: false,
			};
			setShowModal(true);
			await dispatch(testimonialAction.updateTestimonialStatus(data));
		} catch (error) {
			console.error("Failed to reject testimonial:", error);
		}
	};

	const getColorByStatus = (status: any) => {
		switch (status) {
			case 0:
				return "#FFC300";
			case 1:
				return "#008001";
			case 2:
				return "#FF0000";
			default:
				return "#000000";
		}
	};
	const getConversionStatus = (key: any) => {
		switch (key) {
			case 0:
				return "InProgress";
			case 1:
				return "Completed";
			case 2:
				return "Failed";
			default:
				return "-";
		}
	};

	function getEngagementStatus(value: any): JSX.Element {
		if (value === undefined || value === null) {
			const status = "Unknown";
			const cls = status.toLowerCase();
			return (
				<div className="d-flex align-items-center justify-content-center gap-1">
					<span className={`retention-percent ${cls}`}>—</span>
					<span className={`retention-badge ${cls}`}>N/A</span>
				</div>
			);
		}

		const n = Number(value);
		if (Number.isNaN(n)) {
			const status = "Unknown";
			const cls = status.toLowerCase();
			return (
				<div className="d-flex align-items-center justify-content-center gap-1">
					<span className={`retention-percent ${cls}`}>—</span>
					<span className={`retention-badge ${cls}`}>N/A</span>
				</div>
			);
		}

		const clamped = Math.max(0, Math.min(100, n));
		const rounded = Math.round(clamped);

		let status: "Low" | "Medium" | "High" = "High";

		if (clamped < 30) {
			status = "Low";
		} else if (clamped < 60) {
			status = "Medium";
		} else {
			status = "High";
		}

		const displayPercent = rounded;
		const cls = status.toLowerCase();

		return (
			<div className="d-flex align-items-center justify-content-center gap-1">
				<span className={`retention-percent ${cls}`}>
					{displayPercent !== null ? `${displayPercent}%` : "—"}
				</span>
				<span className={`retention-badge ${cls}`}>{status}</span>
			</div>
		);
	}
	const handleActiveTestimonial = async (id: any, status: any) => {
		const data = {
			adminUserId: parseInt(getLoggedUserId()),
			messageId: id,
			isActive: !status,
		};
		setShowModal(true);
		await dispatch(testimonialAction.updateTestimonialVideoStatus(data));
	};

	const handleChangeStatus = (status) => {
		setSelectedStatus(status);
		const body = {
			sortDirection: columnSort?.direction ?? "",
			sortColumn: columnSort?.column ?? "",
			pageNumber: 1,
			pageSize: 25,
			searchText: debouncedSearch,
			messageBoardId: videoHotlineData?.message?.messageBoardId,
			status: isNaN(status) ? null : parseInt(status),
			eventCategoryId: isNaN(selectedCategory) ? null : parseInt(selectedCategory),
		};
		setShowModal(true);
		setCurrentPage(1);
		dispatch(videoHotlineAction.videoHotlineGetByfilter(body));
	};

	const handleChnageCategory = (categoryId) => {
		setSelectedCategory(categoryId);
		const body = {
			sortDirection: columnSort?.direction ?? "",
			sortColumn: columnSort?.column ?? "",
			pageNumber: 1,
			pageSize: 25,
			searchText: debouncedSearch,
			messageBoardId: videoHotlineData?.message?.messageBoardId,
			status: isNaN(selectedStatus) ? null : parseInt(selectedStatus),
			eventCategoryId: isNaN(categoryId) ? null : parseInt(categoryId),
		};
		setShowModal(true);
		setCurrentPage(1);
		dispatch(videoHotlineAction.videoHotlineGetByfilter(body));
	};

	return (
		<div data-testid="videoHotlinePage" className="videohotline-page">
			<div className="card-box-link-back-div">
				<FontAwesomeIcon icon={faChevronLeft} />
				<CardLink
					onClick={() => history.push("/")}
					className="card-box-link-back"
					data-testid="bible-backtolist"
				>
					Back to List
				</CardLink>
			</div>
			<div className="mb-3">
				<div className="d-flex filter-link-container justify-content-between align-items-center">
					<Col lg="9" className="ps-0">
						<Row className="g-3 align-items-center">
							<Col lg="4" className="d-flex">
								<Input
									type="search"
									onChange={(event) => setSearch(event.target.value)}
									className="form-control w-100"
									id="search-filter"
									placeholder="Search here..."
									value={searchText}
								/>
							</Col>
							<Col lg="6" className="d-flex gap-3">
								<Select
									id="statusSelect"
									className="status-select"
									classNamePrefix="rs"
									placeholder="Select status"
									isClearable
									options={[
										{ value: 1, label: "Approved" },
										{ value: 2, label: "Pending" },
										{ value: 0, label: "Rejected" },
									]}
									onChange={(selected) => {
										if (selected) {
											handleChangeStatus(selected.value);
										} else {
											handleChangeStatus("");
										}
									}}
									styles={{
										container: (base) => ({
											...base,
											minWidth: 180,
											flexShrink: 0,
										}),
										control: (base) => ({ ...base, minWidth: 180 }),
										clearIndicator: (base) => ({ ...base, cursor: "pointer" }),
									}}
								/>
								<Select
									id="categorySelect"
									className="category-select"
									placeholder="Select category"
									isClearable
									options={
										eventCategoryList
											? eventCategoryList.map((data: any) => ({
													value: data.eventCategoryId,
													label: data.categoryName,
											  }))
											: []
									}
									onChange={(selected) => {
										if (selected) {
											handleChnageCategory(selected.value);
										} else {
											handleChnageCategory("");
										}
									}}
									styles={{
										container: (base) => ({ ...base, minWidth: 220 }),
										clearIndicator: (base) => ({
											...base,
											cursor: "pointer",
										}),
									}}
								/>
							</Col>
						</Row>
					</Col>
					<Col lg="3" className="d-flex justify-content-end pe-0">
						<Button
							type="submit"
							color="primary"
							data-testid="manageCategory"
							onClick={handleManageCategory}
						>
							Manage Categories
						</Button>
					</Col>
				</div>
			</div>
			<div className="videohotline-table">
				<table className="table table-hover" data-testid="videoHotlineTable">
					<thead data-testid="videoHotlineTableHead">
						<tr key="videohotlinetable">
							<th scope="col" data-testid="id-th">
								#
							</th>
							<th scope="col" data-testid="author-th">
								Author Name
							</th>
							<th scope="col" data-testid="category-name-th">
								Category Name
							</th>
							<th scope="col" data-testid="date-th">
								Created Date
							</th>
							<th scope="col" data-testid="enhance-th">
								Video Status
							</th>
							<th scope="col" data-testid="conversion-status-th">
								Conversion Status
							</th>
							<th scope="col" data-testid="total-click-th">
								{handleGetSortColumn("Total Clicks", "totalclicks")}
							</th>
							<th scope="col" data-testid="unique-click-th">
								{handleGetSortColumn(
									"Unique clicks per user",
									"uniqueusersclicked"
								)}
							</th>
							<th scope="col" data-testid="order-th">
								{handleGetSortColumn("Retention Rate", "avgretentionratio")}
							</th>
							<th scope="col" data-testid="videourl-th">
								Video
							</th>
							<th scope="col" data-testid="action-th">
								Action
							</th>
							<th scope="col" data-testid="status-th">
								Status
							</th>
							<th scope="col" data-testid="delete-th">
								Delete
							</th>
						</tr>
					</thead>
					<tbody key='videoHotlineTableBody' data-testid="videoHotlineTableBody">
						{showModal ? (
							<tr key="loading-spinner">
								<td key='spinner' colSpan={13} className="text-center">
									<Spinner />
								</td>
							</tr>
						) : (
							<>
								{videoHotlineData &&
								videoHotlineData?.items?.allMessages?.length > 0 ? (
									videoHotlineData?.items?.allMessages?.map((data: any) => (
										<>
											<tr key={data?.messageDTO?.messageId}>
												<th scope="row" className="icon-column">
													<a
														href={
															"/videoHotline?id=" + data?.messageDTO?.messageId
														}
														className="detail-link"
														data-testid="episodeDetailButton"
													>
														# {data?.messageDTO?.messageId}
													</a>
												</th>
												<td id="authorName">{getUserFullName(data)}</td>
												<td id="category-name">
													{data?.messageDTO?.categoryName ?? "-"}
												</td>
												<td id="date">
													{new Date(
														data?.messageDTO?.createdAtUtc
													).toLocaleDateString()}
												</td>
												<td id="enhanced">
													<span
														style={{
															color: getColorByVideoStatus(
																data?.messageDTO?.messageAttachments?.[0]
																	?.videoEnhanceStatus
															),
														}}
													>
														{videoEnhanceStatus(
															data?.messageDTO?.messageAttachments?.[0]
																?.videoEnhanceStatus
														)}
													</span>
												</td>
												<td id="conversion-status" className="text-center">
													<span
														style={{
															color: getColorByStatus(
																data?.messageDTO?.messageAttachments?.[0]
																	?.hlsStatus
															),
														}}
													>
														{getConversionStatus(
															data?.messageDTO?.messageAttachments?.[0]
																?.hlsStatus
														)}
													</span>
												</td>
												<td id="total-clicks" className="text-center">
													{data?.messageDTO?.totalClicks}
												</td>
												<td id="unique-clicks" className="text-center">
													{data?.messageDTO?.uniqueUsersClicked}
												</td>
												<td id="retention-rate" className="text-center">
													{getEngagementStatus(
														data?.messageDTO?.avgRetentionRatio
													)}
												</td>
												<td id="videourl" className="text-center">
													<CardLink
														className="card-box-link-title"
														href={
															"/videoHotline?id=" + data?.messageDTO?.messageId
														}
														title={
															data?.messageDTO?.messageAttachments?.messageId
														}
													>
														<FontAwesomeIcon
															className="footer-box-icon"
															icon={faEye}
															data-bs-toggle="tooltip"
															data-bs-placement="bottom"
															title="View video"
														/>
													</CardLink>
												</td>
												<td id="action" className="text-center">
													{data?.messageDTO?.isApproved === true ? (
														<span
															style={{ color: "green", fontWeight: "bold" }}
														>
															Approved
														</span>
													) : data?.messageDTO?.isApproved === false ? (
														<span style={{ color: "red", fontWeight: "bold" }}>
															Rejected
														</span>
													) : (
														<div className="d-flex gap-3 justify-content-center">
															{data?.messageDTO?.messageAttachments?.[0]
																?.videoEnhanceStatus === 0 ? (
																<span>-</span>
															) : (
																<>
																	<FontAwesomeIcon
																		icon={faCheck}
																		title="Approve"
																		className="approve-btn"
																		onClick={() =>
																			approveVideo(data?.messageDTO?.messageId)
																		}
																	/>
																	<FontAwesomeIcon
																		icon={faTimes}
																		title="Reject"
																		className="reject-btn"
																		onClick={() =>
																			rejectVideo(data?.messageDTO?.messageId)
																		}
																	/>
																</>
															)}
														</div>
													)}
												</td>
												<td id="publish" className="text-center">
													{data?.messageDTO?.messageAttachments?.[0]
														?.hlsStatus === 1 && (
														<FormGroup switch>
															<Input
																type="switch"
																className="active-switch"
																id="activeInactiveSwitch"
																checked={data?.messageDTO?.isActive}
																onChange={() =>
																	handleActiveTestimonial(
																		data?.messageDTO?.messageId,
																		data?.messageDTO?.isActive
																	)
																}
															/>
														</FormGroup>
													)}
												</td>
												<td className="icon-column">
													<FontAwesomeIcon
														size="2x"
														icon={faTrashAlt}
														data-testid="promiselandDeleteButton"
														data-bs-toggle="tooltip"
														cursor="pointer"
														data-bs-placement="bottom"
														title="Delete"
														onClick={() =>
															handleSelectForDelete(
																data?.messageDTO?.messageAttachments?.[0]
																	?.messageAttachmentId
															)
														}
													/>
												</td>
											</tr>
										</>
									))
								) : (
									<tr key='no-data-msg'>
										<td colSpan={13} className="text-center h6">
											No Data found.
										</td>
									</tr>
								)}
							</>
						)}
					</tbody>
				</table>
			</div>
			<div className="pagination">
				<ReactPaginate
					previousLabel={"<<"}
					nextLabel={">>"}
					breakLabel={"..."}
					pageCount={Math.ceil(+videoHotlineData?.items?.totalCount / 25)}
					marginPagesDisplayed={2}
					pageRangeDisplayed={3}
					onPageChange={(data) => {
						setCurrentPage(data.selected + 1);
						const body = {
							sortDirection: columnSort?.direction ?? "",
							sortColumn: columnSort?.column ?? "",
							pageNumber: data.selected + 1,
							pageSize: 25,
							searchText: debouncedSearch,
							messageBoardId: videoHotlineData?.message?.messageBoardId,
							status: isNaN(selectedStatus) ? null : parseInt(selectedStatus),
							eventCategoryId: isNaN(selectedCategory)
								? null
								: parseInt(selectedCategory),
						};
						setShowModal(true);
						dispatch(videoHotlineAction.videoHotlineGetByfilter(body));
					}}
					containerClassName={"pagination"}
					pageClassName={"page-item"}
					previousClassName={"page-item"}
					breakClassName={"page-item"}
					breakLinkClassName={"page-link"}
					nextClassName={"page-item"}
					pageLinkClassName={"page-link"}
					previousLinkClassName={"page-link"}
					nextLinkClassName={"page-link"}
					activeClassName={"active"}
					forcePage={currentPage - 1}
				/>
			</div>
			<Modal
				isOpen={showDeleteModal}
				backdrop="static"
				centered
				data-testid="deleteModal"
			>
				<ModalHeader>Delete {title ?? "VideoHotline"}</ModalHeader>
				<ModalBody className="modal-body">
					<form name="deleteTestimoForm">
						<div
							className="col-form-label"
							data-testid="promiseLandDeleteMessage"
						>
							Deleting this {title ?? "VideoHotline"} Video will permanently
							remove. To confirm, please click Confirm Delete.
						</div>
					</form>
				</ModalBody>
				<ModalFooter>
					<Button
						type="button"
						color="secondary"
						data-bs-dismiss="modal"
						onClick={handleCloseClick}
						data-testid="cancelDeleteButton"
					>
						Cancel
					</Button>
					<Button
						type="button"
						color="primary"
						onClick={handleLoadDeleteModal}
						data-testid="confirmDeleteButton"
					>
						Confirm Delete
					</Button>
				</ModalFooter>
			</Modal>
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { videoHotlineData, languageData, testimonialData } = state;
	return {
		videoHotlineData,
		languageData,
		testimonialData,
	};
};

export default connect(mapStateToProps)(VideoHotlineList);
